export const translationHu = {
  header: {
    menu: {
      backToYettel: 'Vissza a Yettel.hu-ra',
      yettelAccount: 'Yettel fiók',
    },
  },
  borgMigration: {
    header: 'Átirányítás',
    subHeader: 'Fiók migráció folyamatban...',
  },
  loginRegister: {
    login: {
      failedToInit: {
        header: 'Hoppá!<br />Valami hiba történt',
        content: 'Valami miatt nem tudjuk betölteni a felületet, dolgozunk a megoldáson. Kérjük próbáld újra később.',
        action: 'Újra próbálom',
      },
      loginError: {
        header: 'Hoppá!<br />Valami hiba történt',
        resendLimitHeader: 'Sikertelen bejelentkezés',
        retryLimitHeader: 'Sikertelen bejelentkezés',
        blockedHeader: 'Gyanús tevékenységet észleltünk, ezért letiltottunk',
        content: 'A bejelentkezés során valami nem sikerült, dolgozunk a megoldáson. Kérjük próbáld újra később.',
        resendLimitContent: 'Túl sokszor kértél új kódot, próbáld meg újra később.',
        retryLimitContent: 'Túl sok próbálkozásod volt, próbáld meg újra később.',
        blockedContent: 'Biztonsági okokból átmenetileg letiltottunk, kérjük, próbálj meg bejelentkezni később újra.',
        action: 'Újra próbálom',
        b2b: {
          title: 'Úgy látjuk ez egy Lakossági Fiókhoz tartozó e-mail cím',
          content:
            'A megadott e-mail cím/jelszó páros egy lakossági előfizetéshez tartozik. Biztos ezzel akarsz bejelentkezni?',
          okLabel: 'Igen, tovább a Lakossági oldalra',
          cancelLabel: 'Nem, vissza',
        },
        b2c: {
          title: 'Úgy látjuk ez egy Üzleti Fiókhoz tartozó e-mail cím',
          content:
            'A megadott e-mail cím/jelszó páros egy üzleti előfizetéshez tartozik. Biztos ezzel akarsz bejelentkezni?',
          okLabel: 'Igen, tovább az Üzleti oldalra',
          cancelLabel: 'Nem, vissza',
        },
        emptyPhoneNumberList: {
          title: 'Nem találtunk elérhető telefonszámot.',
          content: 'A megadott üzleti fiókhoz nem tartozik vagy nem elérhető egy telefonszám sem.',
          okLabel: 'Vissza a bejelentkezéshez',
        },
      },
      box: {
        header: 'Yettel fiók belépés',
        headerb2b: 'Yettel Üzleti fiók belépés',
        headerApp: 'Belépés',
        headerSMS: 'SMS belépés',
        headerSMSb2b: 'Yettel fiók SMS megerősítés',
        email: 'E-mail cím',
        emailTooltip: 'A korábban megadott e-mail címeddel tudsz belépni.',
        password: 'Jelszó',
        login: 'Belépek',
        otherAuthHeader: 'vagy',
        otherAuthHeaderb2b: 'vagy lakossági ügyfeleknek',
        oauthGoogle: 'Belépés Google fiókkal',
        oauthFacebook: 'Belépés Facebook fiókkal',
        oauthApple: 'Belépés Apple fiókkal',
        authSMS: 'SMS kóddal',
        forgottenPassword: 'Elfelejtettem a jelszavam',
        oauthError: {
          header: (provider: string) => `Hoppá!<br />Úgy látszik nincs ${provider} fiók csatolva a profilodhoz.`,
          content: (provider: string) =>
            `Még nem csatoltál yettel fiókot ehhez a ${provider} profilhoz, miután bejelentkeztél e-mail cím jelszóval hozzá társíthatod a fiókodhoz.`,
          action: `Bejelentkezem máshogy`, // ez mi? Dorka - nincs használatban. Tibi
        },
        loginError: {
          invalidEmail: `Érvénytelen e-mail cím.`,
          invalidPassword: `Jelszó megadása kötelező.`,
          invalidUserNameOrPassword: `Hibás e-mail cím, vagy jelszó. Előfordulhat, hogy e-mail címed nincs megerősítve.`,
          sessionTimeout: `A bejelentkezési munkamenet lejárt, jelentkezz be újra.`,
          general: `A bejelentkezés sikertelen. Kérjük próbáld újra később.`,
          invalidCaptcha: `A captcha ellenőrzés sikertelen. Kérjük próbáld újra!`,
          invalidCode: `Hibás kód.`,
          subscriptionCheckError: (link: string) =>
            `SMS kóddal nem tudsz belépni. <a href="${link}">Nézd meg</a> mi lehet a hiba.`,
        },
        register: 'Regisztrálok',
        registerb2b: {
          button: 'Regisztráció',
          infoHeader: 'Hogyan történik a Regisztráció?',
          infoText:
            'Ha döntéshozói e-mail címedet már rögzítettük, és erről értesítést is kaptál, akkor itt befejezheted a regisztrációdat. Ha még nem történt meg az e-mail cím rögzítése, akkor előbb látogass el bármelyik üzletünkbe vagy keress minket telefonon, hogy kollégáink segíthessenek.',
          infoLink: (link: string | undefined) => `<a href="${link}">Bővebben a Regisztrációról</a>`,
          captcha: {
            title: 'Egy pillanat...',
            header: 'Ellenőriznünk kell, hogy nem vagy-e robot, ez pár percet vesz igénybe.',
            send: 'Tovább',
            back: 'Vissza',
          },
        },
        business: {
          title: 'Üzleti ügyfelünk vagy?',
          content: (link: string) =>
            `<a href="${link}">Kattints ide</a>, és átirányítunk az üzleti belépési felületre.`,
        },
        accountUpdateWarning: {
          title: 'Frissítettük a Yettel fiókokat.',
          content: 'Előfordulhat, hogy korábbi fiókodat töröltük, mert a szükséges adatmegerősítés nem történt meg.',
          contentBold:
            'Kattints a Regisztrálok gombra, hozz létre egy új fiókot, hogy újra hozzáférhess a telefonszámaidhoz és folytathasd az ügyintézést.',
        },
      },
      phone: {
        phoneNumber: `Add meg a számot, amire az SMS-t küldjük.`,
        next: `Kérem az SMS kódot`,
        back: `Vissza`,
        code: `Add meg az SMS kódot`,
        sendAgain: `Nem kaptam meg az SMS kódot, újat kérek`,
        login: `Belépek`,
      },
      device: {
        title: 'Add meg a kódot.',
        content: 'A tv képernyőjén láthattál egy kódot, ezt kell ide beírnod.',
        fieldlabel: 'Kód',
        button: 'Küldés',
        codenotfound: `A kód nem érvényes. Kérjük próbáld újra.`,
        senderror: `Váratlan hiba történt. Kérjük próbáld újra később.`,
        success: {
          header: 'Sikeres belépés!',
          subHeader: 'Itt az idő, hogy élvezd a Yettel tv szolgáltatást. Jó mulatást!',
          button: 'Belépés',
        },
      },
      accountLocked: {
        header: `Biztonságod érdekében javasoljuk, hogy cseréld le jelszavad`,
        content: (_videochatLink: string) =>
          `A fiókodban tapasztalt gyanús tevékenységek arra utalnak, hogy illetéktelenek próbálnak hozzáférni adataidhoz.
	   <br />Biztonságod érdekében változtass jelszót.<br />Ha nem szeretnéd jelszavadat megváltoztatni, akkor 
	   várd meg, amíg kollégáink feloldják a fiókod zárolását.`,
        sendConfirmEmail: `Jelszót változtatok`,
        cancel: 'Nem változtatok jelszót',
      },
      updatePassword: {
        header: `Biztonságod érdekében javasoljuk, hogy cseréld le jelszavad`,
        content: `A fiókodban tapasztalt gyanús tevékenységek arra utalnak, hogy illetéktelenek próbálnak hozzáférni adataidhoz.
	   Biztonságod érdekében <br/>&nbsp;<br/>változtass jelszót.<br />Ha nem szeretnéd jelszavadat megváltoztatni, akkor 
	   várd meg, amíg kollégáink feloldják a fiókod zárolását.`,
        sendConfirmEmail: `Jelszót változtatok`,
        ignorePasswordChange: `Nem változtatok jelszót`,
      },
      mfa: {
        authenticator: {
          header: `Add meg az ellenőrző kódot`,
          subHeader: `Írd be a 6 számjegyű kódodat az Autentikátorodból.`,
          inputLabel: `Ellenőrző kód`,
          login: `Belépek`,
        },
        sms: {
          header: `Add meg az ellenőrző kódot`,
          subHeader: (phoneNumber: string) =>
            `Az ellenőrző kódot elküldtük (SMS-ben) a ${phoneNumber} végű telefonszámodra. Ellenőrizd az üzeneteid, majd add meg a kódot.`,
          inputLabel: `Ellenőrző kód`,
          login: `Belépek`,
          backToPhoneNumber: `Vissza a telefonszám megadáshoz`,
          backToLogin: `Vissza a belépéshez`,
          back: `Vissza`,
        },
        selector: {
          header: `Megerősítő telefonszám hozzáadása`,
          subHeader: `Adj meg egy mobilszámot, amihez hozzáköthetjük a második biztonsági lépcsőt a fiókod védelmében. Olyan számot válassz, ami tud SMS-t fogadni, és amihez hosszú távon hozzáférsz.`,
          selectLabel: `Telefonszám`,
          buttonLabel: `Küldés`,
        },
      },
      realmSwitch: {
        header: 'Kijelentkeztettünk',
        message: 'Semmi ok a pánikra, kijelentkeztettünk a biztonságod érdekében. Kérlek, jelentkezz be újra.',
        action: 'Értem, belépek',
      },
      msisdnverification: {
        header: 'SMS-hitelesítés',
        subHeader:
          'A hitelesítő kódot elküldtük kapcsolattartói telefonszámodra, néhány percbe telhet, mire megérkezik. A kapott kódot írd be a lenti mezőbe.',
        action: 'Újraküldés',
        resendAction: 'Új kódot kérek',
        timerSeconds: 'sec',
        invalidCode: (code: string, remaining: string) =>
          `A(z) ${code} kód nem megfelelő, már csak ${remaining} próbálkozásod maradt.`,
      },
    },
    register: {
      box: {
        header: 'Yettel fiók regisztráció',
        name: 'Mi a neved?',
        email: 'Add meg az e-mail címedet',
        register: 'Regisztráció',
        oauthSectionLabel: 'vagy',
        oauthGoogle: 'Regisztráció Google fiókkal',
        oauthFacebook: 'Regisztráció Facebook fiókkal',
        error: 'A fiók regisztráció sikertelen. Kérjük próbáld újra később',
      },
      hero: {
        header: 'Lépj be Yettel fiókoddal!',
        headerb2b: 'Intézd vállalati ügyeidet online Yettel üzleti fiókkal!',
        desc: (appLink: string | undefined, helpLink: string | undefined, regLink: string | undefined) =>
          `Weben egyszerűen vásárolhatsz,<br/>az ügyintézést pedig a ${'<a href="' + appLink + '">Yettel Appban</a>'} érheted el.<br/><br/>Segítségre van szükséged?<br/>Az ${'<a href="' + helpLink + '">online ügyintézés</a>'} és a ${'<a href="' + regLink + '">fiókregisztráció</a>'} oldalon minden fontos infót megtalálsz.<br/>Ha kérdésed van, hívd a 1220‑at, segítünk!`,
      },
      result: {
        header: 'Yettel fiók regisztráció',
        subHeader: 'Az e-mailt elküldtük',
        desc: 'A megadott e-mail címedre elküldtük az aktiváló linket tartalmazó e-mail-t. Kérjük, ellenőrizd postafiókodat és véglegesítsd regisztrációdat, erre 24 óra áll rendelkezésedre, utána újra kell kezdened a regisztrációs folyamatot.',
        resend: 'E-mail újra küldése',
        backToYettelAccount: 'Vissza a Yettel fiókhoz',
      },
    },
    otp: {
      header: 'E-mail megerősítés',
      desc: (email: string | undefined) =>
        `Megerősítő e-mailt küldtünk a(z) <strong>${email}</strong> címre. Kattints az e-mailben lévő gombra, vagy írd be ide a kapott kódot.`,
      changeEmail: 'Másik e-mail címet adok meg',
      sendAgain: 'Új kódot kérek',
      invalidCode: 'A megadott aktiváló kód nem megfelelő',
    },
  },
  accessibility: {
    loading: 'Betöltés folyamatban',
    code: 'Kód',
    qrCode: 'QR kód',
  },
};
export const translationEn: typeof translationHu = {
  header: {
    menu: {
      backToYettel: 'Back to Yettel.hu',
      yettelAccount: 'Yettel account',
    },
  },
  borgMigration: {
    header: 'Redirecting',
    subHeader: 'Account migration is in progress...',
  },
  loginRegister: {
    login: {
      failedToInit: {
        header: 'Error',
        content: 'Failed to initialize login interface. Please try again later.',
        action: 'Try again',
      },
      loginError: {
        header: 'Error',
        resendLimitHeader: 'Unsuccessful login',
        retryLimitHeader: 'Unsuccessful login',
        blockedHeader: 'We detected suspicious activity, so we blocked you',
        content: 'Failed to login. Please try again later.',
        resendLimitContent: 'You requested a new code too many times, please try again later.',
        retryLimitContent: 'Too many attempts, please try again later.',
        blockedContent: 'For security reasons, we have temporarily blocked you. Please try logging in again later.',
        action: 'Try again',
        b2b: {
          title: 'We see that this is an e-mail address belonging to a Residential Account',
          content:
            'The email address/password pair you provided belongs to a residential subscription. Are you sure you want to log in with this?',
          okLabel: 'Yes, continue to the Residential page',
          cancelLabel: 'No, return to login',
        },
        b2c: {
          title: 'We see that this is an e-mail address belonging to a Business Account',
          content:
            'The email address/password pair you provided belongs to a business subscription. Are you sure you want to log in with this?',
          okLabel: 'Yes, continue to the Business page',
          cancelLabel: 'No, return to login',
        },
        emptyPhoneNumberList: {
          title: "We couldn't find an available phone number.",
          content: 'There is no phone number associated with the specified business account or it is not available.',
          okLabel: 'Return to login',
        },
      },
      box: {
        header: 'Yettel account login',
        headerb2b: 'Yettel Business account login',
        headerApp: 'Login',
        headerSMS: 'Yettel account SMS login',
        headerSMSb2b: 'Yettel Account SMS Verification',
        email: 'E-mail address / Username',
        emailTooltip: 'You can login with the e-mail address you provided earlier.',
        password: 'Password',
        login: 'Login',
        otherAuthHeader: 'or',
        otherAuthHeaderb2b: 'or residential customer',
        oauthGoogle: 'Login with Google',
        oauthFacebook: 'Login with Facebook',
        oauthApple: 'Login with Apple',
        authSMS: 'Login with SMS',
        forgottenPassword: 'Forgot your password?',
        oauthError: {
          header: (provider: string) => `Ups! It seems that you don't connection ${provider} account to your profile.`,
          content: (provider: string) =>
            `You haven't connected ${provider} account to your profile. You can connect it after you login with e-mail and password.`,
          action: `Login with e-mail and password`,
        },
        loginError: {
          invalidEmail: `Invalid e-mail address.`,
          invalidPassword: `Password is required.`,
          invalidUserNameOrPassword: `Wrong e-mail address or password. Your email address may not be confirmed.`,
          sessionTimeout: `Your login session has expired, please login again.`,
          general: `Login failed. Please try again later.`,
          invalidCaptcha: `Captcha verification failed. Please try again!`,
          invalidCode: `Invalid code.`,
          subscriptionCheckError: (link: string) =>
            `You can't log in with this number using SMS. <a href="${link}">Check out</a> what might be the problem!`,
        },
        register: 'Register',
        registerb2b: {
          button: 'Registration',
          infoHeader: 'How does Registration work?',
          infoText:
            'If your decision-maker email address has already been registered and you’ve received a notification about it, you can complete your registration here. If the registration hasn’t happened yet, please visit one of our stores or contact us by phone so our colleagues can assist you.',
          infoLink: (link: string | undefined) => `<a href="${link}">More about Registration</a>`,
          captcha: {
            title: 'One moment...',
            header: 'We need to verify that you are not a robot. This may take a few minutes.',
            send: 'Continue',
            back: 'Back',
          },
        },
        business: {
          title: 'Are you a business customer?',
          content: (link: string) =>
            `Due to the background development, you can't log in here. <a href="${link}">Click here</a> to login.`,
        },
        accountUpdateWarning: {
          title: 'Yettel account has been updated.',
          content:
            'Your previous account may have been deleted because the required account verification was not completed.',
          contentBold:
            'Register by tapping the Register button at the bottom of the page, and you can continue managing your services right away.',
        },
      },
      phone: {
        phoneNumber: `Enter the phone number you want to login with`,
        next: `Send me the SMS code`,
        back: 'Back to login',
        code: `Enter the SMS code`,
        sendAgain: `I didn't receive the SMS code, send me another one`,
        login: `Login`,
      },
      device: {
        title: 'Enter the code.',
        content: 'You saw a code on your TV screen, please enter it here.',
        fieldlabel: 'Code',
        button: 'Send',
        codenotfound: `Code is not valid. Please try again.`,
        senderror: `Unexpected error. Please try again later.`,
        success: {
          header: 'Successful login',
          subHeader: "It's time to enjoy the Yettel TV service. Have fun!",
          button: 'Login',
        },
      },
      accountLocked: {
        header: `For your security, we recommend that you change your password.`,
        content: (videochatLink: string) =>
          `The suspicious activity on your account indicates that an unauthorized person has tried to access your account.<br/>&nbsp;<br/>Change your password to protect your account or wait until our colleagues unlock your account or contact us via <a class="button button--text button--no-left-right-padding" href="${videochatLink}">videochat</a>.`,
        sendConfirmEmail: `Change password`,
        cancel: "I don't want to change my password",
      },
      updatePassword: {
        header: `For your security, we recommend that you change your password.`,
        content: `The suspicious activity on your account indicates that an unauthorized person has tried to access your account. Change your password to protect your account.`,
        sendConfirmEmail: `Send confirmation e-mail`,
        ignorePasswordChange: `I don't want to change my password`,
      },
      mfa: {
        authenticator: {
          header: `Enter the verification code`,
          subHeader: `Enter the 6-digit code from your google authenticator.`,
          inputLabel: `Verification code`,
          login: `Login`,
        },
        sms: {
          header: `Enter the verification code`,
          subHeader: (phoneNumber: string) =>
            `We have sent the verification code (SMS) to the phone number ending with ${phoneNumber}. Check your messages and enter the code.`,
          inputLabel: `Verification code`,
          login: `Login`,
          backToPhoneNumber: `back to phone number`,
          backToLogin: `back to login`,
          back: `back`,
        },
        selector: {
          header: `Enter the phone number`,
          subHeader: `Enter the phone number you want to use for two-factor authentication. The chosen number should be able to receive SMS and be available for long term use.`,
          selectLabel: `Phone number`,
          buttonLabel: `Send`,
        },
      },
      realmSwitch: {
        header: 'Logged out',
        message: 'You’ve been logged out for your security. Please log in again.',
        action: 'Got it, logging in',
      },
      msisdnverification: {
        header: 'SMS authentication',
        subHeader:
          'We have sent the verification code to your contact phone number, it may take a few minutes to arrive. Enter the received code in the field below.',
        action: 'Send new code',
        resendAction: 'Send new code',
        timerSeconds: 'sec',
        invalidCode: (code: string, remaining: string) =>
          `The ${code} code is incorrect, you have ${remaining} attempt(s) left.`,
      },
    },
    register: {
      box: {
        header: 'Yettel account registration',
        name: 'What is your name?',
        email: 'Enter your e-mail address',
        register: 'Register',
        oauthSectionLabel: 'or',
        oauthGoogle: 'Register with Google account',
        oauthFacebook: 'Register with Facebook account',
        error: 'Failed to create account. Please try again later.',
      },
      hero: {
        header: 'Log in with your Yettel account!',
        headerb2b: 'Manage your enterprise subscription online with Yettel business account!',
        desc: (appLink: string | undefined, helpLink: string | undefined, regLink: string | undefined) =>
          `You can easily shop online,<br/>and manage your services in the ${'<a href="' + appLink + '">Yettel App</a>'}.<br/><br/>Need help?<br/>You can find all the important information on the ${'<a href="' + helpLink + '">Online Administration</a>'} and ${'<a href="' + regLink + '">Account Registration</a>'} pages.<br/>If you have any questions, call 1220 and we’ll help you!`,
      },
      result: {
        header: 'Yettel account registration',
        subHeader: 'The e-mail has been sent',
        desc: 'Please check your e-mail address and follow the instructions in it.',
        resend: 'Resend e-mail',
        backToYettelAccount: 'Back to Yettel account',
      },
    },
    otp: {
      header: 'Email confirmation',
      desc: (email: string | undefined) =>
        `We have sent an email to ${email}. Click on the button in the email, or enter the received code.`,
      changeEmail: 'Use a different email',
      sendAgain: 'Resend',
      invalidCode: 'The entered activation code is not valid',
    },
  },
  accessibility: {
    loading: 'Loading',
    code: 'Code',
    qrCode: 'QR code',
  },
};
